import React from "react";
import { Route, Routes as Switch } from "react-router-dom";
import NotFound from "./error/NotFound";
import EventoDetalhePage from "./eventos-detalhes/EventoDetalhePage";
import EventosPage from "./eventos/EventosPage";
import TransmissoresPage from "./transmissores/TransmissoresPage";

function Routes() {
  return (
    <Switch>
      <Route path="/transmissores" element={<TransmissoresPage />} />
      <Route path="/" element={<EventosPage />} />
      <Route path="/eventos/:id" element={<EventoDetalhePage />} />
      <Route path="*" element={<NotFound />} />
    </Switch>
  );
}

export default Routes;
